module.exports = __webpack_public_path__ + "img/antes_despues_160.a0c766c2.png";